import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseRed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "12px",
	height: "12px",
	viewBox: "0 0 12 12",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Shape" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Wireframes-Mobile-Agent-Yulia",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Home---Messages",
				transform: "translate(-344.000000, -672.000000)",
				fill: "#ca0037",
				children: /* @__PURE__ */ _jsx("polygon", {
					id: "Shape",
					transform: "translate(350.000000, 678.000000) rotate(45.000000) translate(-350.000000, -678.000000) ",
					points: "349 671 349 677 343 677 343 679 349 679 349 685 351 685 351 679 357 679 357 677 351 677 351 671"
				})
			})
		})
	]
});
export default SvgCloseRed;
